import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonHeader } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { format, compareAsc } from 'date-fns';

//import '../css/hotelCss.css';
import '../../../css/layout.css';

import { ViewInvoiceModal } from '../../../zInternal_Features/merchant/components/Modal_ViewInvoice';
import { OccupiedRoomDetailsModal } from '../../../hotel/merchant/components/Modal_DetailData_OccupiedRoom';
import { OccupiedRoomDetailsModal_multiple } from '../../../hotel/merchant/components/Modal_DetailData_OccupiedRoom_multiple';


export function CashDepositListModal (props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(props.startDate);
    let [endDate, setEndDate] = useState(props.endDate);

    let [viewCashDepositDetailList, setViewCashDepositDetailList] = useState([]);

    let [showCheckedOutRoomDetailsModal, setCheckedOutRoomDetailsModal] = useState(false);
    let [showCheckedOutRoomDetailsModal_multiple, setCheckedOutRoomDetailsModal_multiple] = useState(false);

    let [viewInvoice, setViewInvoice] = useState(false);
    let [invoiceForm, setInvoiceForm] = useState(null);
    let [roomID, setRoomID] = useState(null);
    let [roomSalePrice, setRoomSalePrice] = useState(null);
    let [checkInDateActual, setCheckInDateActual] = useState(null);
    let [merchantInvoiceID, setMerchantInvoiceID] = useState(null);

    useEffect(() => {

        if(props.openModal == true)
        {
            /*
            let formData = new FormData();
            formData.append('Tracker', 74102);
            formData.append('user', acctID);
            formData.append('xStartDateRange', props.startDate.toISOString().substr(0, 10));
            formData.append('xEndDateRange', props.endDate.toISOString().substr(0, 10));
        
            const requestOptions = {
                enctype: 'multipart/form-data',
                method:'POST',
                credentials: 'include',
                files: formData,
                body: formData,
                contentType: false,
                processData: false,
            }
            */

            //alert(authenticatedMerchent_context.startDate);
            //alert(authenticatedMerchent_context.endDate);

            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '00_view_cash_deposit_list',
                    user: acctID,
                    xStartDateRange: props.data.startDate,
                    xEndDateRange: props.data.endDate,
                    sessionID: sessionID,
    
                }),
            }

            let routePath;
            if(authenticatedMerchent_context.authenticated == 'T1')
            {
                routePath = 'hotel_merchantAcct_argsjqApp'
            }
            if(authenticatedMerchent_context.authenticated == 'T2')
            {
                routePath = 'proService_merchantAcct_argsjqApp'
            }
            if(authenticatedMerchent_context.authenticated == 'T3')
            {
                routePath = 'retail_merchantAcct_argsjqApp'
            }
        
            
            fetch(baseURL+routePath, requestOptions)
            .then(res => res.text())
            .then(res => {
        
                let rows = res.toString().split('~~~');
        
                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    if(authenticatedMerchent_context.authenticated == 'T1')
                    {
                        setViewCashDepositDetailList((pervViewCashDepositDetailList) => {
                            return pervViewCashDepositDetailList.concat({
                                roomID: cols[0],
                                roomSalePrice: cols[1],  
                                room_id_multiple: cols[2],                                                          
                                invoiceID: cols[3],
                                customerID: cols[4],
                                invoiceTimeCreated: format(new Date(cols[5]), 'E') + ", " + format(new Date(cols[5]), 'MM/dd'),
                                invoiceForm: cols[6],
                                invoiceName: cols[7],
                                totalOriginalAmount: parseFloat(cols[8]).toFixed(2),
                                amountOutstanding: parseFloat(cols[9]).toFixed(2),

                            })
                        });
                    }
                    else{
                                            
                        setViewCashDepositDetailList((pervViewCashDepositDetailList) => {
                            return pervViewCashDepositDetailList.concat({
                                invoiceID: cols[0],
                                customerID: cols[1],
                                invoiceTimeCreated: format(new Date(cols[2]), 'E') + ", " + format(new Date(cols[2]), 'MM/dd'),
                                invoiceForm: cols[3],
                                invoiceName: cols[4],
                                totalOriginalAmount: parseFloat(cols[5]).toFixed(2),
                                amountOutstanding: parseFloat(cols[6]).toFixed(2),

                            })
                        });
                    }
                } 
            })
        }

    }, [props.openModal]);


    function handleSetViewInvoice(event)
    {
        setInvoiceForm(event);
        setViewInvoice(true);
    }

    function roomDetailModalHandler(event) 
    {

        setRoomID(event[1]);
        setRoomSalePrice(event[2]);
        //setCheckInDateActual(event[3]);
        setMerchantInvoiceID(event[3]);
        setCheckedOutRoomDetailsModal(event[0]);

    }

    function roomDetailModalHandler_multiple(event) {

        setRoomID(event[1]);
        setRoomSalePrice(event[2]);
        //setCheckInDateActual(event[3]);
        setMerchantInvoiceID(event[3]);
        setCheckedOutRoomDetailsModal_multiple(event[0]);

    }

    function closeModalHandler() {

        setViewCashDepositDetailList([]);
        props.closeModal();
    }
 
    return (

        <React.Fragment>
            {props.openModal == true ?
            (
            <IonModal isOpen={ props.openModal }>


                    <IonHeader className='appModalHeader'>
                        <IonText> Cash Deposits </IonText>
                    </IonHeader>

                    <IonGrid className='appGridContent'>
                        <IonRow >
                                {/*<IonCol size='4'>Guest Name</IonCol>*/}
                                <IonCol size='3'>Date</IonCol> 
                                <IonCol size='3'>Charge</IonCol>    
                                <IonCol size='3'>Balance</IonCol>                                                                                                                                                          
                                <IonCol size='3'>Action</IonCol>
                        </IonRow>
                        {viewCashDepositDetailList.map((detailData) =>   {
                            return (
                                <IonRow key={detailData.invoiceID}>
                                    {/*<IonCol size='4'>{detailData.invoiceName}</IonCol>*/}
                                    <IonCol size='3'>{detailData.invoiceTimeCreated}</IonCol>
                                    <IonCol size='3'>{detailData.totalOriginalAmount}</IonCol>
                                    <IonCol size='3'>{detailData.amountOutstanding}</IonCol>
                                    <IonCol size='3'>
                                        <IonButton  onClick={() => handleSetViewInvoice(detailData.invoiceForm)}> View </IonButton>
                                            {authenticatedMerchent_context.authenticated == 'T1' && detailData.room_id_multiple == 'NO' && <IonButton onClick={() => roomDetailModalHandler([true, detailData.roomID, detailData.roomSalePrice, detailData.invoiceID])}> Details </IonButton>}
                                            {authenticatedMerchent_context.authenticated == 'T1' && detailData.room_id_multiple != 'NO' && <IonButton onClick={() => roomDetailModalHandler_multiple([true, detailData.room_id_multiple, detailData.roomSalePrice, detailData.invoiceID])}> M_Details </IonButton>}
                                      </IonCol>
                                </IonRow>
                            )
                        }
                        )}
                    </IonGrid>


                   {viewInvoice == true && <ViewInvoiceModal openModal={ viewInvoice } closeModal={() => setViewInvoice(false)} data={{
                                        fileLocation: `/api/form/${invoiceForm}/${schema}`, 
                                        }}></ViewInvoiceModal>}

                {authenticatedMerchent_context.authenticated == 'T1' && showCheckedOutRoomDetailsModal == true && <OccupiedRoomDetailsModal openModal={ showCheckedOutRoomDetailsModal } closeModal={() => setCheckedOutRoomDetailsModal()} closeModal_updateComplete={() => closeModalHandler()} data={{
                    status: 'checked_out',
                    roomID: roomID, 
                    roomSalePrice: roomSalePrice,
                    merchantInvoiceID: merchantInvoiceID,
                                        }}></OccupiedRoomDetailsModal>}

                {authenticatedMerchent_context.authenticated == 'T1' && showCheckedOutRoomDetailsModal_multiple == true && <OccupiedRoomDetailsModal_multiple openModal={ showCheckedOutRoomDetailsModal_multiple } closeModal={() => setCheckedOutRoomDetailsModal_multiple()} closeModal_updateComplete={() => closeModalHandler()} data={{
                    status: 'checked_out',
                    roomID: roomID, 
                    roomSalePrice: roomSalePrice,
                    merchantInvoiceID: merchantInvoiceID,
                                        }}></OccupiedRoomDetailsModal_multiple>}

                    <IonButton className='button_closeModal_center' onClick={() => closeModalHandler()}> Close </IonButton>
            </IonModal>
            ) : null }
        </React.Fragment>

    )
}